var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "workflow-editor"
    },
    [
      _c("div", { ref: "canvas" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "io-properties-panel" },
        [
          _c("el-scrollbar", {
            ref: "propertiesPanel",
            attrs: { "wrap-class": "scrollbar-wrapper" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "io-import-export" },
        [
          _c(
            "el-button-group",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "medium",
                    title: "Open BPMN diagram from local file system"
                  },
                  on: { click: _vm.openLocalFile }
                },
                [_c("svg-icon", { attrs: { name: "icomoo/199-upload2" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", title: "Create new BPMN diagram" },
                  on: { click: _vm.newDiagram }
                },
                [_c("svg-icon", { attrs: { name: "icomoo/267-plus" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", title: "Save BPMN diagram" },
                  on: { click: _vm.saveDiagram }
                },
                [_c("svg-icon", { attrs: { name: "icomoo/099-floppy-disk" } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button-group",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", title: "Download as BPMN 2.0 file" },
                  on: { click: _vm.saveAsBPMN }
                },
                [_c("svg-icon", { attrs: { name: "icomoo/198-download2" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", title: "Download as SVG image" },
                  on: { click: _vm.saveAsSVG }
                },
                [_c("svg-icon", { attrs: { name: "icomoo/014-image" } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            ref: "inputFile",
            staticStyle: { display: "none" },
            attrs: { type: "file" },
            on: { change: _vm.onUploadChange }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }